import { z } from 'zod';

import { MatchingRecord } from '@eluve/utils';

import { UserFileTypesEnum } from './types';

export const UserFileTypesLookup = {
  SIGNATURE: 'SIGNATURE',
  MEDICAL_CODE_CONFIGS: 'MEDICAL_CODE_CONFIGS',
  CHAT_DOCUMENT: 'CHAT_DOCUMENT',
} as const satisfies MatchingRecord<UserFileTypesEnum>;

export const userFileTypesSchema = z.nativeEnum(UserFileTypesLookup);
